import { Head, Link, router, usePage } from '@inertiajs/react';
import { useState } from 'react';

import { ImageForm } from '@/components/admin/images/ImageForm';
import { ImagesGrid } from '@/components/admin/images/ImagesGrid';
import type { ImageItem } from '@/components/admin/images/ImagesGrid';
import { Button } from '@/components/ui/Button';
import { Modal } from '@/components/ui/Modal';
import { trackUmamiEvent } from '@/lib/analytics';

const CONTEXT_LABELS: Record<string, string> = {
  news: 'Notícias',
  members: 'Membros',
  history: 'História',
  events: 'Eventos',
};

interface ImagesPageProps {
  images: ImageItem[];
  contexts: string[];
  activeContext: string | null;
  [key: string]: unknown;
}

export default function Images() {
  const { images, contexts, activeContext } = usePage<ImagesPageProps>().props;
  const [showForm, setShowForm] = useState(false);

  function handleDelete(id: number) {
    if (!window.confirm('Eliminar esta imagem?')) return;
    trackUmamiEvent('admin_content_delete', { content_type: 'image' });
    router.delete(`/images/${id}`, { preserveScroll: true });
  }

  const allTabActive = !activeContext;

  return (
    <>
      <Head title="Imagens — Administração" />
      <div className="space-y-5">
        <div className="flex items-center justify-between">
          <h1 className="font-headline text-on-surface text-2xl font-bold">Imagens</h1>
          <Button variant="primary" size="sm" onClick={() => setShowForm(true)}>
            <span className="material-symbols-outlined text-[18px]">add</span>
            Nova imagem
          </Button>
        </div>

        {/* Server-side filter tabs */}
        <div className="border-line bg-background flex w-fit gap-1 rounded-md border p-1">
          <Link
            href="/images"
            className={`rounded-sm px-5 py-1.5 text-sm transition-colors ${
              allTabActive
                ? 'bg-surface text-primary font-semibold shadow-sm'
                : 'text-on-surface-light hover:text-on-surface font-medium'
            }`}
          >
            Todas
          </Link>
          {contexts.map((c) => (
            <Link
              key={c}
              href={`/images?context=${c}`}
              className={`rounded-sm px-5 py-1.5 text-sm transition-colors ${
                activeContext === c
                  ? 'bg-surface text-primary font-semibold shadow-sm'
                  : 'text-on-surface-light hover:text-on-surface font-medium'
              }`}
            >
              {CONTEXT_LABELS[c] ?? c}
            </Link>
          ))}
        </div>

        <div className="surface-card p-4">
          <ImagesGrid images={images} onDelete={handleDelete} />
        </div>
      </div>

      <Modal open={showForm} onClose={() => setShowForm(false)} title="Nova imagem">
        <ImageForm contexts={contexts} onClose={() => setShowForm(false)} />
      </Modal>
    </>
  );
}
